import { useMediaQuery } from "react-responsive";


export const useIsBigScreen = () => {
    return useMediaQuery( { query: '(min-width: 900px)' } )
}
